import { LeadFilter } from '../../../../crm/lead/filter';
import { campanhaLeadVisualizacaoModoAmbos } from '../visualizacao-modo';

export class CampanhaLeadFilter extends LeadFilter {
    visualizacaoModo: number;

    constructor() {
        super();
        this.setDefaults();
    }

    private setDefaults() {
        this.visualizacaoModo = campanhaLeadVisualizacaoModoAmbos.id;
    }

    clear() {
        super.clear();
        this.setDefaults();
    }
}
